import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PageBankPayTransactionIndexResponse } from '@/repositories/generated';

const response: PageBankPayTransactionIndexResponse = {
  content: [
    {
      processingDate: '2021-08-01T00:00:00+09:00',
      walletServiceId: '001',
      merchantId: 'BMRS000044',
      merchantTransactionId: '0000000000001202308085060',
      chargeProcessingId: 'c123456',
      paymentType: 'NON_FACE_TO_FACE_BASIS',
      dealType: 'SALES',
      amount: 1000,
      status: 'NORMAL',
      appUserId: '0100000',
      externalUserId: 'test_user001',
      walletServiceName: '〇〇Pay',
      accountMethod: '34',
      storeName: 'テスト店舗',
      terminalId: '8229200010001',
    },
    {
      processingDate: '2021-08-01T00:00:00+09:00',
      walletServiceId: '001',
      merchantId: 'BMRS000044',
      merchantTransactionId: '0000000000001202308085060',
      chargeProcessingId: 'c123456',
      paymentType: 'FACE_TO_FACE',
      dealType: 'SALES',
      amount: 1000,
      status: 'NORMAL',
      appUserId: '0100000',
      externalUserId: 'test_user001',
      walletServiceName: '〇〇Pay',
      accountMethod: '34',
      storeName: 'テスト店舗',
      terminalId: '8229200010001',
    },
    {
      processingDate: '2021-08-01T00:00:00+09:00',
      walletServiceId: '001',
      merchantId: 'BMRS000044',
      merchantTransactionId: '0000000000001202308085060',
      chargeProcessingId: 'c123456',
      paymentType: 'NON_FACE_TO_FACE_BASIS',
      dealType: 'SALES',
      amount: 1000,
      status: 'ABNORMAL',
      appUserId: '0100000',
      externalUserId: 'test_user001',
      walletServiceName: '〇〇Pay',
      accountMethod: '34',
      storeName: 'テスト店舗',
      terminalId: '8229200010001',
    },
    {
      processingDate: '2021-08-01T00:00:00+09:00',
      walletServiceId: '001',
      merchantId: 'BMRS000044',
      merchantTransactionId: '0000000000001202308085060',
      chargeProcessingId: 'c123456',
      paymentType: 'NON_FACE_TO_FACE_BASIS',
      dealType: 'CANCEL',
      amount: 1000,
      status: 'NORMAL',
      appUserId: '0100000',
      externalUserId: 'test_user001',
      walletServiceName: '〇〇Pay',
      accountMethod: '34',
      storeName: 'テスト店舗',
      terminalId: '8229200010001',
    },
  ],
  pageable: {
    sort: {
      empty: true,
      sorted: false,
      unsorted: true,
    },
    offset: 0,
    pageNumber: 0,
    pageSize: 20,
    paged: true,
    unpaged: false,
  },
  totalElements: 4,
  totalPages: 1,
  last: true,
  size: 20,
  number: 0,
  sort: {
    empty: true,
    sorted: false,
    unsorted: true,
  },
  numberOfElements: 4,
  first: true,
  empty: false,
};

export const bankPay = http.get(
  createMockEndpoint('/bankpay_transaction'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
